<section class="cmn-innerpage-wrapper">
  <div class="tab-content-wrapper">
    <form [formGroup]="templateForm">
      <div class="employee-form-wrapper">
        <div class="grid-wrapper-4">
          <div class="form-wrapper">
            <label for="">Template Name <span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter Template Name"
                formControlName="templateName"
                maxlength="45"
              />
            </mat-form-field>
            <div
              class="custom-error"
              *ngIf="
            templateForm.get('templateName')?.invalid &&
            templateForm.get('templateName')?.touched
          "
            >
              <span>
                <mat-error
                  *ngIf="templateForm.get('templateName')!.touched &&
                    templateForm.get('templateName')!.hasError('required')"
                  >Template name is required</mat-error
                >
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Template Code <span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter Template Code"
                formControlName="code"
                maxlength="45"
              />
            </mat-form-field>
            <div
              class="custom-error"
              *ngIf="
            templateForm.get('code')?.invalid &&
            templateForm.get('code')?.touched
          "
            >
              <span>
                <mat-error
                  *ngIf="templateForm.get('code')!.touched &&
                    templateForm.get('code')!.hasError('required')"
                  >Template code is required</mat-error
                >
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <span>
              <label for="">Channel<span class="red">*</span></label>
            </span>
            <mat-form-field>
              <mat-select
                placeholder="Select Channel"
                formControlName="channel"
              >
                <mat-option value="Email">Email</mat-option>
                <mat-option value="SMS">SMS</mat-option>
                <mat-option value="PUSH">PUSH</mat-option>
                <mat-option value="Whatsapp">Whatsapp</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="
                     templateForm.get('channel')!?.touched &&
                     templateForm.get('channel')?.hasError('required')"
                >
                  Channel is required
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Subject<span class="red">*</span></label>
            <mat-form-field>
              <textarea
                matInput
                placeholder="Enter Subject"
                formControlName="subject"
                maxlength="45"
              >
              </textarea>
            </mat-form-field>
            <div
              class="custom-error"
              *ngIf="
          templateForm.get('subject')?.invalid &&
          templateForm.get('subject')?.touched
        "
            >
              <span>
                <mat-error
                  *ngIf="templateForm.get('subject')!.touched &&
                  templateForm.get('subject')!.hasError('required')"
                  >Subject is required</mat-error
                >
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <div class="flex-wrapper">
              <div>
                <label for="">Placeholder<span class="red">*</span></label>
                <mat-form-field>
                  <textarea
                    matInput
                    placeholder="Enter placeholder"
                    formControlName="placeholders"
                    maxlength="45"
                    #placeholderInput
                  >
                  </textarea>
                </mat-form-field>
                </div>
                <div>
                  <button class="add-items-btn" type="button" (click)="addPlaceholder(placeholderInput.value)">
                    <img src="../../../assets/images/icons/icon-add-color.svg" alt="" />
                  </button>
                </div>
            </div>
            </div>
         
            <div class="form-wrapper">
              <label for="">Body<span class="red">*</span></label>
              <mat-form-field>
                <textarea
                  matInput
                  placeholder="Enter Body"
                  formControlName="body"
                  #bodyTextarea
                ></textarea>
              </mat-form-field>
              <div
                class="custom-error"
                *ngIf="templateForm.get('body')?.invalid && templateForm.get('body')?.touched"
              >
                <span>
                  <mat-error
                    *ngIf="templateForm.get('body')!.touched &&
                    templateForm.get('body')!.hasError('required')"
                  >
                    Body is required
                  </mat-error>
                </span>
              </div>
            </div>
            </div>
            <div class="placeholder-wrapper">
              <div *ngFor="let item of placeholderArray; let i = index">
                <button type="button" (click)="selectPlaceholder(item, bodyTextarea)" >
                  <span>
                    <h6>{{ item }}</h6>
                  </span>
                  <span (click)="onRemove(i)"
                  ><img src="assets/images/icons/icon-delete.svg"
                /></span>
                </button>
              </div>
            </div>
      </div>
      <div class="submit-btn-wrapper flex-middle">
        <button
          class="cmn-next-btn"
          (click)="onAddTemplate()"
          [disabled]="loading"
        >
          <span *ngIf="!loading">{{templateId ? 'Update':'Add'}} Template</span>
          <span *ngIf="loading">Loading...</span>
        </button>
      </div>
    </form>
  </div>
</section>
